//todo: přidat tlačítko konverze a zkontrolovat db parametr v ADM

namespace Gordic.Epk.WebControls {

    export interface IUpresnitVyrizeniFormEpk {
        /** gcontent */
        cnt: GContentType<GEpkDbParamsNew>,
        /** funkční místo ze session */
        sessionIxsFunFlag: boolean,
        /** hodnota čas. razítka ze šablony (-1 = nenastaveno, 0 = NE, 1  = ANO) */
        sablonaCasRazitko: number,
    }

    export class UpresnitVyrizeniFormEpk {

        private stringSuffix: string = ".js-static";
        private setVyriditButtons(gcontent: GContentType<GEpkDbParamsNew>, sessionIxsFunFlag: boolean) {
            var multi = false;
            var MenuButtonsService = new Gordic.Epk.WebControls.MenuButtonsService();
            gcontent.vyriditState = MenuButtonsService.setButtons({
                gcontent: gcontent, actions: gcontent.actions, sessionIxsFunFlag: sessionIxsFunFlag, multi: false
            }, {
                vyridit: gcontent.menuSchvalit.enabled, posoudit: gcontent.menuPosoudit.enabled, zamitnout: gcontent.menuZamitnout.enabled
            }, {
                schvalitVyrizeniSpisu: gcontent.schvaleniVyrizeniSpisu.checked,
                pridelit: gcontent.pridelit.checked, predat: gcontent.predat.checked,
                podepsat: gcontent.podepsat.checked, posoudit: gcontent.posoudit.checked, schvalit: gcontent.schvalit.checked, vzitnavedomi: gcontent.vzitnavedomi.checked,
                rozhodnout: gcontent.rozhodnout.checked, splnit: gcontent.splnit.checked, podepsatPrilohy: gcontent.podepsatPrilohy.checked
            });
        }

        /**
         * vytvořit formulář upřesnění vyřízení
         */
        public create(opt: IUpresnitVyrizeniFormEpk) {

            var gcontent = opt.cnt;
            var sessionIxsFunFlag = opt.sessionIxsFunFlag;
            var sablonaCasRazitko = opt.sablonaCasRazitko;

            let main = $("<div>");
            let form = $("<div>").appendTo(main);

            let Form = new Gordic.Forms.Form({
                name: "FormUpresnitVyrizeni",
                layoutDescriptor: "L3M3S1, L-2-6-4, M-4-8-0, S-12-12-0"
            });

            //#region -- Obraz --

            Form
                .addSection("jres:32000521") //RC 32000521 : Obraz

            //#region * Podepsat dokument *

            var podepsatDisabled = !gcontent.podepsat.enabled;
            if (gcontent.EpkParams.ssl_epk_plus! === -1) {
                // thazmuka (3.5.2022) - na hodnotu tohoto parametru ssl_epk_plus === -1 (kvůli MHMP)
                // ponechat zobrazený, ale needitovatelný
                podepsatDisabled = true;
            }

            Form
                .addRow()
                .addField("gcheck", {
                    name: 'checkPodepsat',
                    label: "jres:26265056", //RC 26265056 : Podepsat
                    tooltip: "jres:26265056", //RC 32000037 : Podepsat dokument
                    change: (ev, obj) => {
                        if (obj.value === null)
                            obj.value = false;
                        gcontent.podepsat.checked = obj.value;
                        changeButtonOnStatusBar($(".podepsat_status_class" + this.stringSuffix).parent(), gcontent.podepsat.checked);
                        // row by měl být vždy dostupný
                        new GEpkCommon().preSetStates({
                            cnt: gcontent,
                            row: (gcontent as any).row,
                            sessionIxsFunFlag: sessionIxsFunFlag,
                            setChecks: false,
                            multi: false
                        });
                        this.setStatesSection(gcontent, form);
                    },
                    disabled: podepsatDisabled
                })

            //#endregion

            //#region * Časové razítko *

            var casRazitkoVisible = sablonaCasRazitko > -1 ? true : gcontent.casoveRazitko.visible === true;

            if (casRazitkoVisible === true) {
                Form
                    .addRow()
                    .addField("gcheck", {
                        name: 'checkCasRazitko',
                        label: "jres:32000053", //RC 32000053 : Časové razítko
                        tooltip: "jres:32000052", //RC 32000052 : Přidat k podpisu časové razítko
                        change: (ev, obj) => {
                            if (obj.value === null)
                                obj.value = false;
                            gcontent.casoveRazitko.checked = obj.value;
                            changeButtonOnStatusBar($(".casrazitko_status_class" + this.stringSuffix).parent(), obj.value);
                        },
                        disabled: !gcontent.casoveRazitko.enabled
                    })
            }

            //#endregion

            //#region * Zkonvertovat obraz *

            if (Gordic.Wfl.WebClient.GetGWflDBParams().IsUkraine !== true) {

                if (gcontent.zkonvertovat.visible === true) {
                    Form
                        .addField("gcheck", {
                            initialValue: gcontent.zkonvertovat.checked,
                            name: 'checkKonverze',
                            label: "jres:32000250", //RC 32000250 : Zkonvertovat
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.zkonvertovat.checked = obj.value;
                                changeButtonOnStatusBar($(".konverze_status_class" + this.stringSuffix).parent(), obj.value);
                            },
                            disabled: !gcontent.zkonvertovat.enabled
                        })
                }

            }

            //#endregion

            //#endregion

            //#region -- Požadavek --

            Form
                .addSection("jres:26265013") //RC 26265013 : Požadavek


            //#region * Požadavek schválení *

            var schvalitDisabled = !gcontent.schvalit.enabled;
            if (gcontent.EpkParams.ssl_epk_plus! === -1) {
                // thazmuka (3.5.2022) - na hodnotu tohoto parametru ssl_epk_plus === -1 (kvůli MHMP)
                // ponechat zobrazený, ale needitovatelný
                schvalitDisabled = true;
            }

            Form
                .addRow()
                .addField("gcheck", {
                    name: 'checkSchvalit',
                    label: "jres:26265058", //RC 26265058 : Schválit
                    tooltip: "jres:32000039", //RC 32000039 : Schválit dokument
                    change: (ev, obj) => {
                        if (obj.value === null)
                            obj.value = false;
                        gcontent.schvalit.checked = obj.value;
                        changeButtonOnStatusBar($(".schvalit_status_class" + this.stringSuffix).parent(), gcontent.schvalit.checked);
                        this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                    },
                    disabled: schvalitDisabled
                })

            //#endregion

            //#region * Vyřídit žádost posouzením *

            if (gcontent.EpkParams.ssl_epk_plus! > 0) {

                Form
                    .addRow()
                    .addField("gcheck", {
                        name: 'checkPosoudit',
                        label: "jres:26265059", //RC 26265059 : Posoudit
                        tooltip: "jres:32000054", //RC 32000054 : Vyřídit žádost posouzením
                        change: (ev, obj) => {
                            if (obj.value === null)
                                obj.value = false;
                            gcontent.posoudit.checked = obj.value;
                            changeButtonOnStatusBar($(".posoudit_status_class" + this.stringSuffix).parent(), obj.value);
                            this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                        },
                        disabled: !gcontent.posoudit.enabled
                    })

            }

            //#endregion

            if (gcontent.EpkParams.ssl_epk_plus === 2 || gcontent.EpkParams.ssl_epk_plus === 3) {

                //#region * Vzít na vědomí *

                Form
                    // VZÍT NA VĚDOMÍ
                    .addRow()
                    .addField("gcheck", {
                        name: 'checkVzitNaVedomi',
                        label: "jres:32000207", //RC 32000207 : Vzít na vědomí
                        change: (ev, obj) => {
                            if (obj.value === null)
                                obj.value = false;
                            gcontent.vzitnavedomi.checked = obj.value;
                            changeButtonOnStatusBar($(".vzitnavedomi_status_class" + this.stringSuffix).parent(), obj.value);
                            this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                        },
                        disabled: !gcontent.vzitnavedomi.enabled
                    })

                //#endregion

                if (gcontent.EpkParams.ssl_epk_plus === 3) {

                    //#region * Splnit *

                    Form
                        // SPLNIT (SPECIALA PRO UKRAJINU)
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkSplnit',
                            label: "jres:32000429", //RC 32000429 : Splnit
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.splnit.checked = obj.value;
                                changeButtonOnStatusBar($(".splnit_status_class" + this.stringSuffix).parent(), obj.value);
                                this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                            },
                            disabled: !gcontent.splnit.enabled
                        })

                    //#endregion

                    //#region * Rozhodnout *

                    Form
                        // ROZHODNOUT (SPECIALITA PRO UKRAJINU)
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkRozhodnout',
                            label: "jres:32000450", //RC 32000450 : Rozhodnout
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.rozhodnout.checked = obj.value;
                                changeButtonOnStatusBar($(".rozhodnout_status_class" + this.stringSuffix).parent(), obj.value);
                                this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                            },
                            disabled: !gcontent.rozhodnout.enabled
                        })

                    //#endregion

                }

                if (gcontent.EpkParams.ssl_epk_plus2 === true) {
                    Form
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkPridelit',
                            label: "jres:32000628", //RC 32000628 : Přidělit
                            tooltip: "jres:32000628", //RC 32000628 : Přidělit
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.pridelit.checked = obj.value;
                                changeButtonOnStatusBar($(".prideleni_status_class" + this.stringSuffix).parent(), obj.value);
                                this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                            },
                            disabled: !gcontent.pridelit.enabled
                        })


                    Form
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkPredat',
                            label: "jres:32000629", //RC 32000629 : Předat
                            tooltip: "jres:32000629", //RC 32000629 : Předat
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.predat.checked = obj.value;
                                changeButtonOnStatusBar($(".predani_status_class" + this.stringSuffix).parent(), obj.value);
                                this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                            },
                            disabled: !gcontent.predat.enabled
                        })
                    Form
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkSchvalitVyrizeniSpisu',
                            label: "jres:32000643", //RC 32000643 : Schválit vyřízení spisu
                            tooltip: "jres:32000643", //RC 32000643 : Schválit vyřízení spisu
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.schvaleniVyrizeniSpisu.checked = obj.value;
                                changeButtonOnStatusBar($(".schvalit_vyrizeni_spisu_status_class" + this.stringSuffix).parent(), obj.value);
                                this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                            },
                            disabled: !gcontent.predat.enabled
                        })
                }
              
            }

            //#endregion

            //#region -- Přílohy --

            if (Gordic.Wfl.WebClient.GetGWflDBParams().IsUkraine !== true) {

                //#region * Podepsat přílohy *

                // pokud jsou invisible podepsat přílohy, tak nejsou vidět ani ostatní volby
                if (gcontent.podepsatPrilohy.visible === true) {

                    Form
                        .addSection("jres:32000033") //RC 32000033 : Přílohy

                    Form
                        .addRow()
                        .addField("gcheck", {
                            name: 'checkPriloha',
                            label: "jres:32000246", //RC 32000246 : Podepsat přílohy
                            change: (ev, obj) => {
                                if (obj.value === null)
                                    obj.value = false;
                                gcontent.podepsatPrilohy.checked = obj.value;
                                changeButtonOnStatusBar($(".priloha_status_class" + this.stringSuffix).parent(), obj.value);

                                // row by měl být vždy dostupný
                                new GEpkCommon().preSetStates({
                                    cnt: gcontent,
                                    row: (gcontent as any).row,
                                    sessionIxsFunFlag: sessionIxsFunFlag,
                                    setChecks: false,
                                    multi: false
                                });

                                this.setStatesSection(gcontent, form);
                            },
                            disabled: !gcontent.podepsatPrilohy.enabled
                        })

                    //#endregion

                    //#region * Časové razítko k příloze *

                    var casRazitkoPriloha = sablonaCasRazitko > -1 ? true : gcontent.casoveRazitkoPriloha.visible === true;

                    if (casRazitkoPriloha === true) {

                        Form
                            .addRow()
                            .addField("gcheck", {
                                name: 'checkCasRazitkoPriloha',
                                label: "jres:32000053", //RC 32000053 : Časové razítko
                                tooltip: "jres:32000248", //RC 32000248 : Časové razítko (přílohy)
                                change: (ev, obj) => {
                                    if (obj.value === null)
                                        obj.value = false;
                                    gcontent.casoveRazitkoPriloha.checked = obj.value;
                                    this.setVyriditButtons(gcontent, sessionIxsFunFlag);
                                },
                                disabled: !gcontent.casoveRazitkoPriloha.enabled
                            })

                    }

                    //#endregion

                    //#region -- Zkonvertovat přílohy -- 

                    if (gcontent.zkonvertovatPrilohy.visible === true) {
                        Form
                            .addField("gcheck", {
                                initialValue: gcontent.zkonvertovatPrilohy.checked,
                                name: 'checkKonverzePriloha',
                                label: "jres:32000250", //RC 32000250 : Zkonvertovat
                                tooltip: "jres:32000522", //RC 32000522 : Zkonvertovat (přílohy)
                                change: (ev, obj) => {
                                    if (obj.value === null)
                                        obj.value = false;
                                    gcontent.zkonvertovatPrilohy.checked = obj.value;
                                    //changeButtonOnStatusBar($(".konverze_status_class" + this.stringSuffix).parent(), obj.value);
                                },
                                disabled: !gcontent.zkonvertovatPrilohy.enabled
                            })
                    }

                    //#endregion

                    //#region -- podepsat i ne PDF přílohy -- 

                    if (gcontent.podepsatPrilohyNePDF.visible === true) {
                        Form
                            .addField("gcheck", {
                                initialValue: gcontent.podepsatPrilohyNePDF.checked,
                                name: 'checkPodepsatPrilohyNePDF',
                                label: "jres:32000523", //RC 32000523 : Podepsat i ne-PDF
                                tooltip: "jres:32000524", //RC 32000524 : Podepsat i ne-PDF přílohy
                                change: (ev, obj) => {
                                    if (obj.value === null)
                                        obj.value = false;
                                    gcontent.podepsatPrilohyNePDF.checked = obj.value;
                                    //changeButtonOnStatusBar($(".konverze_status_class" + this.stringSuffix).parent(), obj.value);
                                },
                                disabled: !gcontent.podepsatPrilohyNePDF.enabled
                            })
                    }

                    //#endregion

                }

            }

            //#endregion

            form.gform("createFrom", Form);

            let formTwo = $("<div>").appendTo(main);
            let FormTwo = new Gordic.Forms.Form({
                name: "FormDuvodVyrizeniOptional",
            });

            var settlementReason = "";
            var keyPath = "";

            if (gcontent.row != null)
                keyPath = String.Format("settlementReason.{0}{1}", gcontent.row.ixp!, gcontent.row?.ser_cislo?.toString());

            if (gcontent.globalSettings != null && keyPath !== "") {
                var value: string = gcontent.globalSettings.get(keyPath);
                settlementReason = value == null ? "" : value.trim();
            }

            FormTwo
                .addSection("jres:32000829") //RC 32000829 : Důvod vyřízení
                .addRow("jres:32000830")    //RC 32000830 : Důvod
                .addField("gstringbox", Gordic.Prefabs.Field.charCounter(254), {
                    initialValue: settlementReason, //gcontent.duvod_vyrizeni,
                    validators: [
                        new Gordic.Validators.Length({ max: 254, message: "jres:32000831" }) //RC 32000831 : Pole může obsahovat max. 254 znaků.
                    ], 
                    name: "duvod_vyrizeni",
                    rows: 8,
                    change: (ev, obj) => {
                        if (gcontent.globalSettings != null && keyPath !== "")
                            gcontent.globalSettings.set(keyPath, obj.value);
                    }
                })

            formTwo.gform("createFrom", FormTwo);
            return main;

        }

        /** nastavení stavů v sekci  */
        private setStatesSection(cnt: GContentType<GEpkDbParamsNew>, section: JQuery<HTMLElement>) {

            var checkCasRazitko = section.findFields("checkCasRazitko");
            var checkKonverze = section.findFields("checkKonverze");

            checkCasRazitko.gfield("option", { disabled: !cnt.casoveRazitko.enabled });
            checkKonverze.gfield("option", { disabled: !cnt.zkonvertovat.enabled });

            var checkCasRazitkoPriloha = section.findFields("checkCasRazitkoPriloha");
            var checkKonverzePriloha = section.findFields("checkKonverzePriloha");
            var checkPodepsatPrilohyNePDF = section.findFields("checkPodepsatPrilohyNePDF");

            checkCasRazitkoPriloha.gfield("option", { disabled: !cnt.casoveRazitkoPriloha.enabled });
            checkKonverzePriloha.gfield("option", { disabled: !cnt.zkonvertovatPrilohy.enabled });
            checkPodepsatPrilohyNePDF.gfield("option", { disabled: !cnt.podepsatPrilohyNePDF.enabled });

        }

        /**
         * nasetovaní dat do formuláře
         */
        public setDataToForm(gcontent: GContent & GEpkDbParamsNew, modalWindow: JQuery<HTMLElement>) {
            modalWindow.findFields("checkPodepsat").gfield("setValue", gcontent.podepsat.checked);
            modalWindow.findFields("checkSchvalit").gfield("setValue", gcontent.schvalit.checked);
            modalWindow.findFields("checkPosoudit").gfield("setValue", gcontent.posoudit.checked);
            modalWindow.findFields("checkVzitNaVedomi").gfield("setValue", gcontent.vzitnavedomi.checked);
            modalWindow.findFields("checkSplnit").gfield("setValue", gcontent.splnit.checked);
            modalWindow.findFields("checkRozhodnout").gfield("setValue", gcontent.rozhodnout.checked);

            modalWindow.findFields("checkSchvalitVyrizeniSpisu").gfield("setValue", gcontent.schvaleniVyrizeniSpisu.checked);
            modalWindow.findFields("checkPredat").gfield("setValue", gcontent.predat.checked);
            modalWindow.findFields("checkPridelit").gfield("setValue", gcontent.pridelit.checked);

            modalWindow.findFields("checkCasRazitko").gfield("setValue", gcontent.casoveRazitko.checked);
            modalWindow.findFields("checkKonverze").gfield("setValue", gcontent.zkonvertovat.checked);      // chyběl - thazmuka (15.4.2020)

            modalWindow.findFields("checkPriloha").gfield("setValue", gcontent.podepsatPrilohy.checked);
            modalWindow.findFields("checkCasRazitkoPriloha").gfield("setValue", gcontent.casoveRazitkoPriloha.checked);
            modalWindow.findFields("checkKonverzePriloha").gfield("setValue", gcontent.zkonvertovatPrilohy.checked);
            modalWindow.findFields("checkPodepsatPrilohyNePDF").gfield("setValue", gcontent.podepsatPrilohyNePDF.checked);
        }

    }

}